<template>
  <div class="text-xs-center">
    <v-data-table
      :headers="headers"
      :items="riders"
      :loading="loading_message"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <!-- <td>{{ props.item.user_info.user_code }}</td> -->
        <td class="text-xs-center">{{ props.item.users.users_id }}</td>
        <td class="text-xs-center" v-if="isLoadingDistrict == false">
          <ul>
            <li
              v-for="(district, i) in JSON.parse(
                props.item.user_info.ri_district_id
              )"
              :key="i"
            >
              {{
                districtList.find((val) => val.district_id == district)
                  .district_name_th
              }}
            </li>
          </ul>
        </td>
        <td class="text-xs-center" v-else>
          <v-progress-circular
            :size="27"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </td>
        <td>{{ props.item.users.users_name }}</td>
        <td>{{ props.item.users.users_email }}</td>
        <td class="text-xs-center">{{ props.item.users.users_phone }}</td>
        <td v-if="props.item.users.user_status == 1" class="text-xs-center">
          actived
        </td>
        <td
          v-else-if="props.item.users.user_status == 2"
          class="text-xs-center"
        >
          Pending
        </td>
        <td v-else class="text-xs-center">Inactive</td>
        <td class="text-xs-center">
          <v-tooltip top>
            <v-btn
              icon
              slot="activator"
              :to="
                '/weserve_admin_login/control/' +
                  $store.state.backOffice.province +
                  '/rider/isapprove/' +
                  props.item.users.id
              "
            >
              <v-icon>how_to_reg</v-icon>
            </v-btn>
            <span>Check data</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center">
          <v-tooltip top>
            <v-btn
              icon
              slot="activator"
              :to="
                '/weserve_admin_login/control/' +
                  $store.state.backOffice.province +
                  '/rider/rider/' +
                  props.item.users.id
              "
            >
              <v-icon small>remove_red_eye</v-icon>
            </v-btn>
            <span>View</span>
          </v-tooltip>

          <!-- <v-tooltip top>
          <v-btn icon slot="activator"><v-icon small>delete</v-icon></v-btn>
          <span>Delete</span>
          </v-tooltip>-->
        </td>
      </template>
      <template slot="no-data">
        <div v-if="loading_message == false">No data available</div>
        <div v-else>
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular
          >Loading data ...
        </div>
      </template>
    </v-data-table>
    <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
    </div>-->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: ["riders"],
  data() {
    return {
      isLoadingDistrict: false,
      districtList: [],
      loading_message: false,
      pagination: {
        rowsPerPage: 10,
      },
      headers: [
        // { text: "Rider code", align: "center", sortable: false, value: "name" },
        {
          text: "Username",
          value: "calories",
          align: "center",
          sortable: false,
        },
        { text: "Area", value: "fat", align: "center", sortable: false },
        { text: "Name", value: "carbs", align: "center", sortable: false },
        { text: "Email", value: "protein", align: "center", sortable: false },
        { text: "Tel.", value: "iron", align: "center", sortable: false },
        { text: "Status", value: "status", align: "center", sortable: false },
        { text: "Approve", value: "action", align: "center", sortable: false },
        { text: "Actions", value: "action", align: "center", sortable: false },
      ],
    };
  },
  computed: {
    ...mapState({
      riders_pending: (state) => state.fetchRiderListBack.riders_pending,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
  },
  pages() {
    this.pagination.totalItems = this.riders_pending.length;
    if (
      this.pagination.rowsPerPage == null ||
      this.pagination.totalItems == null
    )
      return 0;

    return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
  },
  methods: {
    ...mapActions({
      getDistrictCore: "fetchProvinceBack/getDistrictCore",
    }),
    async approveRider(item) {
      let obj_clone = JSON.parse(JSON.stringify(item));
      obj_clone.users.user_status = 1;
      let sendata = { id: item.users.id, data: obj_clone };

      await this.$store.dispatch("fetchRiderListBack/approveRider", sendata);
    },
    async fetchRiderList() {
      this.loading_message = true;
      await this.$store.dispatch("fetchRiderListBack/getRiderPendingList");
      this.loading_message = false;
    },
    async fetchDistrictList() {
      let province = this.$route.params.province;
      this.isLoadingDistrict = true;
      let provinceItem = this.provinceData.find(
        (val) =>
          val.province_name_en.toLowerCase().replace(/ /g, "") == province
      );
      this.districtList = await this.getDistrictCore(provinceItem.province_id);
      this.isLoadingDistrict = false;
    },
  },
  async created() {
    this.fetchRiderList();
    this.fetchDistrictList();
  },
};
</script>

<style scoped></style>
